
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const upsellId = 'CartDrawer-Upsell';
  let requestNumber = 0;
  let refreshTimer;

  async function getJSON(url, options) {
    const response = await fetch(url, options);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Request failed');
    }

    return data;
  }

  async function loadUpsells() {
    const container = document.getElementById(upsellId);
    if (!container) return;

    const currentRequest = ++requestNumber;

    try {
      const cart = await getJSON(root + 'cart.js');

      if (currentRequest !== requestNumber) return;
      if (!cart.items.length) {
         document.getElementById(upsellId)?.replaceChildren();
        return;
      }

      // Use the first cart product as recommendation source.
      const productId = cart.items[0].product_id;

      
        /*
        * Fetch recommendations and resolve child products
        * to their parent products via retail_product_url.
        */

        const url = new URL(
        root + 'recommendations/products',
        window.location.origin
        );

        url.searchParams.set('section_id', 'cart-upsell-parents');
        url.searchParams.set('product_id', productId);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', 'related');

        // 1. Fetch the server-rendered metafield mappings.
        const response = await fetch(url);
        

        if (!response.ok) {
        throw new Error('Unable to fetch upsell recommendations');
        }

        const html = await response.text();
        

        if (currentRequest !== requestNumber) return;

        // 2. Parse parent-product references.
        const doc = new DOMParser().parseFromString(
        html,
        'text/html'
        );
       

        const mappings = [
        ...doc.querySelectorAll('.cart-upsell-parent-map')
        ];

        if (!mappings.length) {
            console.warn(
                'No parent mappings found. Check metafield namespace, ' +
                'product references, and recommendation section.'
            );
        }

        // 3. Exclude products already in the cart.
        const cartProductIds = new Set(
        cart.items.map(item => String(item.product_id))
        );

        // 4. Keep unique parent products.
        const uniqueParents = new Map();

        mappings.forEach(element => {
        const parentId = element.dataset.parentId;
        const parentHandle = element.dataset.parentHandle;

        if (!parentId || !parentHandle) return;

        if (cartProductIds.has(String(parentId))) return;

        if (!uniqueParents.has(parentId)) {
            uniqueParents.set(parentId, parentHandle);
        }
        });

        // 5. Load actual parent products.
        // Fetch more candidates than needed in case
        // some parent products are unavailable.
        const parentHandles = [...uniqueParents.values()];

        // const parentResults = await Promise.all(
        // parentHandles.map(async handle => {
        //     try {
        //     return await getJSON(
        //         root + 'products/' +
        //         encodeURIComponent(handle) + '.js'
        //     );
        //     } catch (error) {
        //     console.warn('Unable to load parent:', handle, error);
        //     return null;
        //     }
        // })
        // );


        const parentResults = await Promise.all(
          parentHandles.map(async handle => {
            try {
              const productPath =
                root + 'products/' + encodeURIComponent(handle);

              const [product, swatchResponse] = await Promise.all([
                getJSON(productPath + '.js'),
                fetch(productPath + '?section_id=cart-upsell-swatch-data')
              ]);

              product.upsellSwatches = [];

              if (swatchResponse.ok) {
                const html = await swatchResponse.text();
                const doc = new DOMParser().parseFromString(
                  html,
                  'text/html'
                );

                const swatchJSON = doc.querySelector(
                  '#CartUpsellSwatchData'
                );

                if (swatchJSON) {
                  try {
                    product.upsellSwatches = JSON.parse(
                      swatchJSON.textContent
                    );
                  } catch (error) {
                    console.warn('Invalid swatch JSON:', handle, error);
                  }
                }
              }

              return product;

            } catch (error) {
              console.warn('Unable to load parent:', handle, error);
              return null;
            }
          })
        );


        if (currentRequest !== requestNumber) return;

        // 6. Display a maximum of 2 available parents.
        const products = parentResults
        .filter(product =>
            product &&
            product.available &&
            !cartProductIds.has(String(product.id))
        )
        .slice(0, 2);


      const activeContainer = document.getElementById(upsellId);

      if (currentRequest !== requestNumber || !activeContainer) {
        return;
      }

      activeContainer.replaceChildren();

      if (!products.length) return;

      const heading = document.createElement('h3');
      heading.className = 'cart-drawer-upsell__heading';
      heading.textContent = 'You May Also Like';

      const list = document.createElement('div');
      list.className = 'cart-drawer-upsell__products';

      const formatter = new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        {
          style: 'currency',
          currency: cart.currency
        }
      );

      products.forEach(product => {
        const row = document.createElement('div');
        row.className = 'cart-drawer-upsell__product';
        let image = null;

        const link = document.createElement('a');
        link.className = 'cart-drawer-upsell__title';
        link.href = product.url;
        link.textContent = product.title;

        if (product.featured_image) {
          image = document.createElement('img');
          image.src = product.featured_image;
          image.alt = product.title;
          image.loading = 'lazy';
          image.className = 'cart-drawer-upsell__image';
          row.appendChild(image);
        }

        const details = document.createElement('div');
        details.className = 'cart-drawer-upsell__details';

        const price = document.createElement('div');
        price.className = 'cart-drawer-upsell__price';
        price.textContent = formatter.format(product.price / 100);

        details.append(link, price);

      /* ----- Upsell Color Swatches + Variant Selector ----- */

      const selectors = [];
      const selectedValues = [];

      let selectedVariant = null;
      let isAdding = false;

      // Color swatch lookup from Shopify category metafield
      const swatchMap = new Map(
        (product.upsellSwatches || []).map(item => [
          String(item.label).trim().toLowerCase(),
          item
        ])
      );

      // Color swatches above size/dropdown row
      const swatchRow = document.createElement('div');
      swatchRow.className = 'cart-drawer-upsell__swatches';

      // Size dropdown and add button
      const actions = document.createElement('div');
      actions.className = 'cart-drawer-upsell__actions';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-drawer-upsell__button';
      button.textContent = '+ Add';

      // Set initial values from first available variant
      const firstAvailable = product.variants.find(v => v.available);

      product.options.forEach((option, index) => {
        const isColor = /^(color|colour)$/i.test(option.name.trim());

        selectedValues[index] =
          firstAvailable?.options[index] ||
          option.values[0];

        if (isColor) {
          const group = document.createElement('div');
          group.className = 'cart-drawer-upsell__color-group';

          const swatchButtons = [];

          option.values.forEach(value => {
            const swatch = swatchMap.get(
              String(value).trim().toLowerCase()
            );

            const swatchButton = document.createElement('button');
            swatchButton.type = 'button';
            swatchButton.className = 'cart-drawer-upsell__swatch';
            swatchButton.title = value;
            swatchButton.setAttribute('aria-label', value);
            swatchButton.setAttribute('aria-pressed', 'false');

            if (swatch?.image) {
              swatchButton.style.backgroundImage =
                `url("${swatch.image}")`;
            } else if (swatch?.color) {
              swatchButton.style.backgroundColor = swatch.color;
            } else {
              // Fallback for colors without metafield mapping
              swatchButton.style.backgroundColor = value;
            }

            swatchButton.addEventListener('click', () => {
              if (isAdding) return;
              selectedValues[index] = value;
              updateVariant();
            });

            group.appendChild(swatchButton);
            swatchButtons.push({ element: swatchButton, value });
          });

          selectors.push({
            index,
            type: 'color',
            buttons: swatchButtons
          });

          swatchRow.appendChild(group);

        } else {
          const select = document.createElement('select');
          select.className = 'cart-drawer-upsell__select';
          select.setAttribute('aria-label', option.name);

          option.values.forEach(value => {
            const optionElement = document.createElement('option');
            optionElement.value = value;
            optionElement.textContent = value;
            select.appendChild(optionElement);
          });

          select.value = selectedValues[index];

          select.addEventListener('change', () => {
            if (isAdding) return;
            selectedValues[index] = select.value;
            updateVariant();
          });

          selectors.push({
            index,
            type: 'dropdown',
            element: select
          });

          actions.appendChild(select);
        }
      });

      actions.appendChild(button);

      // Place color swatches above actions
      if (swatchRow.children.length) {
        details.appendChild(swatchRow);
      }

      details.appendChild(actions);

      // Match the exact variant selected
      function updateVariant() {
        selectedVariant = product.variants.find(variant =>
          selectedValues.every((value, index) =>
            variant.options[index] === value
          )
        );

        const available = selectedVariant?.available === true;

        button.disabled = !available || isAdding;

        button.textContent = isAdding
          ? 'Adding...'
          : available
            ? '+ Add'
            : 'Unavailable';

        // Update price and variant image
        if (selectedVariant) {
          price.textContent = formatter.format(
            selectedVariant.price / 100
          );
        }

        if (image) {
          image.src =
            selectedVariant?.featured_image?.src ||
            product.featured_image;
        }

        // Update selected swatch outline
        selectors.forEach(selector => {
          if (selector.type === 'color') {
            selector.buttons.forEach(({ element, value }) => {
              const active = selectedValues[selector.index] === value;

              element.classList.toggle('is-selected', active);
              element.setAttribute('aria-pressed', String(active));

              // Mark color unavailable if no variant
              // with this color is in stock.
              const colorAvailable = product.variants.some(v =>
                v.available &&
                v.options[selector.index] === value
              );

              element.disabled = !colorAvailable || isAdding;
              element.classList.toggle(
                'is-unavailable',
                !colorAvailable
              );
            });
          } else {
            selector.element.disabled = isAdding;
          }
        });
      }

      updateVariant();

      // Add selected parent variant to Dawn cart drawer
      button.addEventListener('click', async () => {
        if (isAdding || !selectedVariant?.available) return;

        isAdding = true;
        updateVariant();

        try {
          const result = await getJSON(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: selectedVariant.id,
                quantity: 1
              }],
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname
            })
          });

          const drawer = document.querySelector('cart-drawer');

          if (drawer?.renderContents &&
              result.sections?.['cart-drawer']) {
            drawer.renderContents(result);
            scheduleRefresh();
          } else {
            window.location.href = root + 'cart';
          }

        } catch (error) {
          const message = document.createElement('p');
          message.className = 'cart-drawer-upsell__error';
          message.textContent = error.message;
          details.appendChild(message);

        } finally {
          isAdding = false;
          updateVariant();
        }
      });





        row.appendChild(details);
        list.appendChild(row);
      });

      if (currentRequest !== requestNumber) return;

      const latestContainer = document.getElementById(upsellId);

      if (latestContainer === activeContainer) {
        latestContainer.append(heading, list);
      }

    } catch (error) {
      console.error('Cart upsell error:', error);
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(loadUpsells, 150);
  }

  
function initUpsells() {
  // Initial page load
  loadUpsells();

  const drawer = document.querySelector('cart-drawer');

  if (!drawer) {
    console.warn('Upsell: Cart drawer not found');
    return;
  }

  const observer = new MutationObserver(mutations => {
    const shouldRefresh = mutations.some(mutation => {
      if (mutation.type !== 'childList') return false;

      const target = mutation.target;

      if (!(target instanceof Element)) return false;

      // Ignore mutations inside our upsell component.
      if (target.closest('#' + upsellId)) return false;

      // React when Dawn replaces cart items or sections.
      return [...mutation.addedNodes].some(node => {
        if (!(node instanceof Element)) return false;

        return (
          node.matches(
            'cart-drawer-items, #CartDrawer-CartItems, .drawer__inner'
          ) ||
          node.querySelector(
            'cart-drawer-items, #CartDrawer-CartItems'
          ) !== null
        );
      });
    });

    if (shouldRefresh) {
      scheduleRefresh();
    }
  });

  observer.observe(drawer, {
    childList: true,
    subtree: true
  });

  // Dawn's built-in cart update event.
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      scheduleRefresh();
    });
  }
}


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpsells);
  } else {
    initUpsells();
  }
})();
